export default "__VITE_ASSET__Cn_ofbyW__"